import styled from 'styled-components';

export const Activities = styled.div`
  background: white;
  min-height: 100%;
`
